import { CoffeeOffIcon } from './CoffeeOffIcon';

/**
 * author: Michael Irigoyen
 * id E3C8FAA1-E273-44BC-8C43-1CB0E5E5C2AB
 * name coffee-off
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-off.svg
 * tags
 * - Food / Drink 
 */
export const TeaOffIcon = CoffeeOffIcon;
export default TeaOffIcon